<template>
  <div class="friends">
    <div class="top-content">
      <svg-icon icon-class="wave2"
                class="wave"></svg-icon>
      <div class="user">
        <div class="circle">
          <img v-if="userDetail && userDetail.wechatInfo" :src="userDetail.wechatInfo.headimgurl" alt="">
          <img v-else src="@/assets/friends/avater.png"
               alt />
        </div>
        <p class="name">{{userDetail.userInfo.realname}}</p>
        <p class="tip">{{userDetail.userInfo.sign}}</p>
        <div class="total">
          <div class="number">
            <span>{{userDetail.userInfo.attention}}</span>关注
            <span></span>|
            <span>{{userDetail.userInfo.idol}}</span> 粉丝
          </div>
          <Button class="btn"
                  @click="attentionUser(userId)">{{isAttention?'已关注':'+ 关注'}}</Button>
        </div>
        <Tabs value="1"
              class="tabs">
          <TabPane label="作品"
                   name="1">
            <Menu mode="horizontal"
                  active-name="1">
              <MenuItem name="1"
                        @click.native="getUserWorkList()">发布的作品（{{getLength(userWorkResult)}}）</MenuItem>
              <MenuItem name="2"
                        @click.native="getUserStarWorkList()">赞过的作品（{{getLength(userStarWorkResult)}}）</MenuItem>
            </Menu>
            <Row v-show="workTabType==1"
                 type="flex"
                 style="margin-top: 20px">
              <i-col span="6"
                     class="card-list"
                     v-for="(item, index) in userWorkResult.records"
                     :key="index">
                <Card :shadow="true"
                      class="card">
                  <div class="pic"
                       @click="toDetail(item.id)">
                    <img :src="item.coverFileUrl"
                         alt />
                  </div>
                  <div class="content">
                    <p class="title"
                       @click="toDetail(item.id)">{{ item.workName }}</p>
                    <Row type="flex"
                         justify="space-between">
                      <i-col span="8">初学者</i-col>
                      <i-col span="8">{{ item.workType_dictText }}</i-col>
                    </Row>

                    <Icon class="vm"
                          type="md-thumbs-up"
                          size="22"
                          color="#d9d9d9" />
                    <span class="vm"
                          style="font-size: 13px; margin-right: 19px">{{ item.starNum }}</span>
                    <Icon class="vm"
                          type="md-eye"
                          size="23"
                          color="#d9d9d9" />
                    <span class="vm"
                          style="font-size: 13px">
                      {{
                      item.viewNum
                      }}
                    </span>
                  </div>
                  <Row type="flex"
                       align="middle"
                       justify="space-between"
                       class="footer">
                    <i-col span="15">
                      <svg-icon class="vm"
                                style="font-size: 30px"
                                icon-class="user"
                                @click="toFriend(item.userId)"></svg-icon>
                      <span class="vm"
                            @click="toFriend(item.userId)">{{ item.realname }}</span>
                    </i-col>
                    <i-col span="9">{{item.createTime.split(' ')[0]}}</i-col>
                  </Row>
                </Card>
              </i-col>
            </Row>
            <Row v-show="workTabType==2"
                 type="flex"
                 style="margin-top: 20px">
              <i-col span="6"
                     class="card-list"
                     v-for="(item, index) in workRankResult.records"
                     :key="index">
                <Card :shadow="true"
                      class="card">
                  <div class="pic"
                       @click="toDetail(item.id)">
                    <img :src="item.coverFileUrl"
                         alt />
                  </div>
                  <div class="content">
                    <p class="title"
                       @click="toDetail(item.id)">{{ item.workName }}</p>
                    <Row type="flex"
                         justify="space-between">
                      <i-col span="8">初学者</i-col>
                      <i-col span="8">{{ item.workType_dictText }}</i-col>
                    </Row>

                    <Icon class="vm"
                          type="md-thumbs-up"
                          size="22"
                          color="#d9d9d9" />
                    <span class="vm"
                          style="font-size: 13px; margin-right: 19px">{{ item.starNum }}</span>
                    <Icon class="vm"
                          type="md-eye"
                          size="23"
                          color="#d9d9d9" />
                    <span class="vm"
                          style="font-size: 13px">
                      {{
                      item.viewNum
                      }}
                    </span>
                  </div>
                  <Row type="flex"
                       align="middle"
                       justify="space-between"
                       class="footer">
                    <i-col span="15">
                      <svg-icon class="vm"
                                style="font-size: 30px"
                                icon-class="user"
                                @click="toFriend(item.userId)"></svg-icon>
                      <span class="vm"
                            @click="toFriend(item.userId)">{{ item.realname }}</span>
                    </i-col>
                    <i-col span="9">{{item.createTime.split(' ')[0]}}</i-col>
                  </Row>
                </Card>
              </i-col>
            </Row>
          </TabPane>
          <TabPane label="专题"
                   name="2">
            <Menu mode="horizontal"
                  active-name="1">
              <MenuItem name="1">发布的专题（0）</MenuItem>
            </Menu>
            <img style="width:100%" src="@/assets/friends/theme.png" alt="">
          </TabPane>
          <TabPane label="帖子"
                   name="3">
            <Menu mode="horizontal"
                  active-name="1">
              <MenuItem name="1">发布的帖子（0）</MenuItem>
            </Menu>
            <img style="width:100%" src="@/assets/friends/theme.png" alt="">
            <div v-if="false" class="post">
              <p>小图标内容元素</p>
              <Row>
                <i-col span="6"
                       v-for="(item, index) in list"
                       :key="index"
                       style="margin-bottom: 30px">
                  <Row>
                    <i-col span="5">
                      <span class="icon">icon</span>
                    </i-col>
                    <i-col span="18">
                      <p class="title">全新PC客户端</p>
                      <p class="content">对游戏玩家来说，无论是团队FPS、MOBA竞技还是生存类游戏，稳定、低延迟是获胜的关键。</p>
                    </i-col>
                  </Row>
                </i-col>
              </Row>
            </div>
          </TabPane>
          <TabPane label="收藏"
                   name="4">
            <Menu mode="horizontal"
                  active-name="1">
              <MenuItem name="1">收藏的作品（{{getLength(collectWorkResult)}}）</MenuItem>
            </Menu>
            <Row type="flex"
                 style="margin-top: 20px">
              <i-col span="6"
                     class="card-list"
                     v-for="(item,index) in collectWorkResult.records"
                     :key="index">
                <Card :shadow="true"
                      class="card"
                      :key="index">
                  <div class="pic"
                       @click="toDetail(item.id)">
                    <img :src="item.coverFileUrl"
                         alt />
                  </div>
                  <div class="content">
                    <p class="title"
                       @click="toDetail(item.id)">{{ item.workName }}</p>
                    <Row type="flex"
                         justify="space-between">
                      <i-col span="8">初学者</i-col>
                      <i-col span="8">{{ item.workType_dictText }}</i-col>
                    </Row>

                    <Icon class="vm"
                          type="md-thumbs-up"
                          size="22"
                          color="#d9d9d9" />
                    <span class="vm"
                          style="font-size: 13px; margin-right: 19px">{{ item.starNum }}</span>
                    <Icon class="vm"
                          type="md-eye"
                          size="23"
                          color="#d9d9d9" />
                    <span class="vm"
                          style="font-size: 13px">{{item.viewNum}}</span>
                  </div>
                  <Row type="flex"
                       align="middle"
                       justify="space-between"
                       class="footer">
                    <i-col span="15">
                      <svg-icon class="vm"
                                style="font-size: 30px"
                                icon-class="user"
                                @click="toFriend(item.userId)"></svg-icon>
                      <span class="vm"
                            @click="toFriend(item.userId)">{{ item.realname }}</span>
                    </i-col>
                    <i-col span="9">{{item.createTime.split(' ')[0]}}</i-col>
                  </Row>
                </Card>
              </i-col>
            </Row>
          </TabPane>
          <TabPane label="好友"
                   name="5">
            <Menu mode="horizontal"
                  active-name="1">
              <MenuItem name="1"
                        @click.native="getFllowUserList()">TA的关注（{{getLength(fllowUserResult)}}）</MenuItem>
              <MenuItem name="2"
                        @click.native="getFansList()">TA的粉丝（{{getLength(fansResult)}}）</MenuItem>
            </Menu>
            <Row v-show="friendsTabType==1"
                 type="flex"
                 justify="space-between"
                 style="margin-top: 20px">
              <i-col span="4"
                     class="card-list2"
                     v-for="(item,index) in fllowUserResult.records"
                     :key="index">
                <Card :shadow="true"
                      class="card">
                  <div class="pic">
                    <svg-icon icon-class="avater"
                              alt />
                  </div>
                  <div class="content">
                    <p class="title">{{item.realname}}</p>
                    <span class="number">作品 {{item.workNum}}</span>
                    <span style="margin:0 6px">|</span>
                    <span class="number">粉丝 {{item.idol}}</span>
                  </div>
                  <p>
                    <Button class="btn"
                            @click="attentionUser(item.id)">{{isAttentionList[item.id]?'已关注':'+ 关注'}}</Button>
                  </p>
                </Card>
              </i-col>
            </Row>
            <Row v-show="friendsTabType==2"
                 type="flex"
                 justify="space-between"
                 style="margin-top: 20px">
              <i-col span="4"
                     class="card-list2"
                     v-for="(item,index) in fansResult.records"
                     :key="index">
                <Card :shadow="true"
                      class="card">
                  <div class="pic">
                    <svg-icon icon-class="avater"
                              alt />
                  </div>
                  <div class="content">
                    <p class="title" @click="toFriend(item.id)">{{item.realname}}</p>
                    <span class="number">作品 {{item.workNum}}</span>
                    <span style="margin:0 6px">|</span>
                    <span class="number">粉丝 {{item.idol}}</span>
                  </div>
                  <p>
                    <Button class="btn"
                            @click="attentionUser(item.id)">{{isAttentionList[item.id]?'已关注':'+ 关注'}}</Button>
                  </p>
                </Card>
              </i-col>
            </Row>
          </TabPane>
        </Tabs>
        <!-- <div class="leave">
          <p>留言</p>
          <Input
            value=""
            type="textarea"
            :rows="6"
            placeholder="文明友善，互相学习"
          />
          <Button class="btn2">留言</Button>
        </div>-->
      </div>
    </div>
  </div>
</template>
<script>
import {
  getUserDetail,
  attentionUser,
  isAttentionUser,
  fansList,
  fllowUserList,
  collectWorkList,
  userWorkList,
  listStarWork
} from "@/api/community";
export default {
  data () {
    return {
      workRankResult: {},
      list: [{}, {}, {}, {}, {}, {}],
      userId: "",
      userDetail: { userInfo: {}, wechatInfo: {} },
      fansResult: {},
      fllowUserResult: {},
      friendsTabType: 1,
      workTabType: 1,
      collectWorkResult: {},
      userWorkResult: {},
      userStarWorkResult: {},
      isAttention: false,
      isAttentionList: []
    };
  },
  mounted () {
    this.userId = this.$route.query.userId;
    this.getUserInfo();
  },
  methods: {
    getLength (result) {
      if (
        result == undefined ||
        result == null ||
        result.records == undefined ||
        result.records == null
      ) {
        return 0;
      }
      return result.records.length;
    },
    getUserInfo () {
      var that = this
      getUserDetail(this.userId).then(res => {
        if (res.success) {
          this.userDetail = res.result;
          isAttentionUser(this.userId).then(res=>{
            this.isAttention = res.success
          })
          this.getFllowUserList();
          this.getCollectWorkList();
          this.getUserWorkList()
        } else {
          this.$Message.info(res.message);
        }
      });
    },
    isAttentionUser(userId){
        isAttentionUser(userId).then(res=>{
          this.isAttentionList[userId] = res.success
       })
    },
    getUserWorkList () {
      this.workTabType = 1;
      userWorkList(
        this.userId,
        null,
        null,
        null,
        null,
        null,
        "create_time",
        false,
        1,
        999
      ).then(res => {
        this.userWorkResult = res.result;
      });
    },
    getUserStarWorkList () {
      this.workTabType = 2;
      listStarWork(this.userId).then(res => {
        if (res.success) {
          this.userStarWorkResult = res.result;
        }
      });
    },
    attentionUser (userId) {
      attentionUser(userId).then(res => {
        if (res.success) {
          this.$Message.success(res.message);
          if(res.message == "关注成功！"){
            this.isAttention = true;
          }else if(res.message == "取消成功！"){
            this.isAttention = false;
          }
        }
      });
    },
    getCollectWorkList () {
      collectWorkList(this.userId).then(res => {
        if (res.success) {
          this.collectWorkResult = res.result;
        }
      });
    },
    getFansList () {
      this.friendsTabType = 2;
      fansList(this.userId).then(res => {
        if (res.success) {
          this.fansResult = res.result;
          for(var i=0;i<this.fansResult.records.length;i++){
            this.isAttentionUser(this.fansResult.records[i].id)
          }
        }
      });
    },
    getFllowUserList () {
      this.friendsTabType = 1;
      fllowUserList(this.userId).then(res => {
        if (res.success) {
          this.fllowUserResult = res.result;
          for(var i=0;i<this.fllowUserResult.records.length;i++){
            this.isAttentionUser(this.fllowUserResult.records[i].id)
          }
        }
      });
    },
    toDetail (workId) {
      this.$router.push({
        path: `/task-detail?workId=${workId}`
      });
    },
    toFriend (userId) {
      this.$router.push({
        path: `/friends?userId=${userId}`
      });
    }
  }
};
</script>
<style lang="scss">
.friends {
  .tabs {
    width: 1205px;
    margin: 30px auto 0;
    .ivu-tabs-bar {
      border: none;
    }
    .ivu-tabs-nav {
      line-height: 1.3;
      float: unset;
      .ivu-tabs-tab {
        font-size: 20px;
        margin-right: 30px;
        color: #fff;
      }
      .ivu-tabs-tab-active {
        background-color: rgb(56, 126, 189);
        font-weight: 700;
        border-radius: 30px;
        color: #fff;
      }
      .ivu-tabs-ink-bar {
        background: unset;
      }
    }
  }
  .ivu-menu-light {
    background: unset;
  }
  .ivu-menu {
    margin-bottom: 30px;
  }
  .ivu-card-shadow {
    box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.2);
  }
}
</style>
<style lang="scss" scoped>
.friends {
  background: rgb(237, 241, 247);
  margin-top: -71px;
  padding-top: 70px;
  overflow: hidden;
  height: 100%;
  position: relative;

  .top-content {
    background: rgb(237, 241, 247);
    height: 1500px;
    .wave {
      height: 500px;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      width: 170%;
      top: -49px;
    }
    .user {
      height: 1500px;
      width: 100%;
      color: #fff;
      padding-top: 80px;
      position: absolute;
      top: 70px;
      left: 50%;
      transform: translateX(-50%);
      .circle {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        border: 3px solid #fff;
        margin: 0 auto;
        // padding-top: 10px;
        background-color: rgba(2, 167, 240, 1);
        img {
          border-radius: 50%;
          width: 100%;
          height: 100%;
          // width: 64px;
          // height: 50px;
        }
      }
      .name {
        line-height: 45px;
        font-size: 20px;
        font-weight: 700;
      }
      .tip {
        font-size: 13px;
        font-weight: 400;
        margin-bottom: 10px;
      }
      .total {
        .number {
          display: inline-block;
          span {
            letter-spacing: 2px;
            font-size: 20px;
            margin: 0 5px;
          }
        }
        .btn {
          background: #fff;
          color: #39a5ef;
          line-height: 15px;
          padding: 8px 16px;
          border-radius: 20px;
          margin-left: 30px;
        }
      }
      .theme {
        width: 1072px;
        height: 579px;
        margin: 0 auto;
      }
      .post {
        background: #fff;
        text-align: left;
        padding: 20px;
        > p {
          color: #999;
          margin-bottom: 50px;
          font-size: 13px;
          font-weight: 700;
        }
        .icon {
          border-radius: 50%;
          display: block;
          color: #fff;
          width: 50px;
          height: 50px;
          line-height: 50px;
          background-color: rgba(228, 228, 228, 1);
          font-size: 14px;
          text-align: center;
          margin-top: 10px;
        }
        .title {
          font-size: 18px;
          font-weight: 700;
          color: #333;
          line-height: 40px;
        }

        .content {
          color: #999;
          font-size: 13px;
          line-height: 1.9;
        }
      }
      .card-list {
        // margin-right: 30px;
        margin-bottom: 20px;
        &:last-child {
          margin-right: 0;
        }
        .card {
          width: 280px;
          text-align: left;
          color: #999;
          .pic {
            width: 100%;
            height: 185px;
            overflow: hidden;
            img {
              width: 100%;
              height: 185px;
              transition: all 0.2s ease-out;
              &:hover {
                transform: scale(1.05);
              }
            }
          }
          .content {
            padding: 8px 20px;

            border-bottom: 1px solid #e8e8e8;
            .title {
              color: #666;
              font-size: 16px;
              font-weight: bold;
              overflow: hidden;
              text-overflow:ellipsis;
              white-space: nowrap;
            }
          }
          .footer {
            padding: 4px 20px;
          }
        }
      }
      .card-list2 {
        margin-right: 20px;
        margin-bottom: 20px;
        &:last-child {
          margin-right: 0;
        }
        .card {
          text-align: center;
          width: 210px;
          color: #999;
          .pic {
            margin: 0 auto;
            width: 100px;
            height: 100px;
            overflow: hidden;
            svg {
              width: 100%;
              height: 100%;
              transition: all 0.2s ease-out;
              &:hover {
                transform: scale(1.05);
              }
            }
          }
          .content {
            padding: 8px 20px;
            .title {
              color: #666;
              font-size: 16px;
              font-weight: bold;
              margin-bottom: 20px;
            }
            .number {
              font-size: 13px;
              color: #666;
            }
          }
          .btn {
            background: #39a5ef;
            color: #fff;
            line-height: 15px;
            padding: 4px 26px;
            border-radius: 20px;
          }
        }
      }

      .leave {
        position: absolute;
        bottom: 30px;
        height: 256px;
        width: 1131px;
        background: #fff;
        padding: 20px 40px;
        text-align: right;
        p {
          font-size: 20px;
          color: #333;
          margin-bottom: 10px;
          text-align: left;
        }
        .btn2 {
          margin-top: 15px;
          background: #39a5ef;
          color: #fff;
          line-height: 15px;
          padding: 4px 20px;
          border-radius: 20px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/friends.vue